module.exports = __webpack_public_path__ + "static/media/services-shape-2.48916fb1.svg";